import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { INAAction } from '../../model/ina-action';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { LstQuestionValueDataView, Section } from '../model/inaSchoolEnrollments';
import { Shared } from '../../service/shared';
import { InaService } from '../../service/ina.service';
import { LastGradeAttendeds, RelationToChild } from '../../model/relation-To-Child';
import { StepAction } from '../model/stepAction';
import { TrackingHistories, TrackingHistory } from '../../service/history';


@Component({
  selector: 'app-osy',
  templateUrl: './osy.component.html',
  styleUrls: ['./osy.component.scss']
})
export class OsyComponent implements OnInit {
  @Input('step') step: number;
  @Input('action') action: INAAction;
  @Output() prevOrNextStep = new EventEmitter<StepAction>();
  @Output() valid = new EventEmitter<boolean>();
  @Output() updateHistory = new EventEmitter<TrackingHistory>();

  frmOsy: UntypedFormGroup;
  section: Section;
  shared: Shared;
  notifyAction: string = '';
  inaStatusTypeId: number;

  relationShipData: RelationToChild[] = [];
  lstlastGradeAttendeds: LastGradeAttendeds[] = [];
  lstTrackHistory: TrackingHistory[] = [];
  trackHistories: TrackingHistories = new TrackingHistories();

  constructor(
    private fb: UntypedFormBuilder, 
    private inaService: InaService
  ) {
    this.shared = new Shared(inaService);
    this.trackHistories.inaHistory = [];
    this.relationShipData = this.shared.getRelationships();

    this.lstlastGradeAttendeds = this.shared.getLastGradeAttendeds();
    this.frmOsy = this.fb.group({
      radioMarriedPartner: [],
      radioChildren: [],
      gradeAttended: [],
      where: [],
      radioSpeaking: [],
      radioReading: [],
      radioWriting: [],
      radioPreferred: [],
      preferredOther: [],
      radioYouth: [],
      chkContracted: [],
      radioAccessTT: [],
      accessTT: [],

      radioTypeOfHousing: [],
      //radioYouthlivesWith: [],
      chkWithaCrew: [],
      chkWithFriends: [],
      chkWithParents: [],
      chkSpouseChildren: [],
      chkYouthLivesOther: [],

      youthlivesWithOther: [],
      chkElaEslELD: [],
      chkGedHep: [],
      chkHomeLanguage: [],
      chkJobTraining: [],
      chkInterestedOther: [],
      interestedOther: [],
      chkInterestedNone: [],
      chkDays: [],
      chkEvenings: [],
      chkSaturday: [],
      chkSunday: [],
      chkAvailabilityOther: [],
      availabilityOther: [],
      chkEducational: [],
      chkHealth: [],
      chkReferralCommunity: [],
      chkInterviewOther: [],
      interviewOther: [],
      emergencyContact: [],
      relationship: [],
      phone: []
    });
  }
  ngAfterViewInit(): void {
    this.fireValidation();
  }
  fireValidation() {
    if (this.action != INAAction.View) {
      if (this.chkElaEslELD.value == true ||
        this.chkGedHep.value == true ||
        this.chkHomeLanguage.value == true ||
        this.chkJobTraining.value == true ||
        this.chkInterestedOther.value == true ||
        this.chkInterestedNone.value == true) {
        this.frmOsy.setErrors(null);
      }
      else {
        this.frmOsy.setErrors({ required: true, invalid: 'Select Health Needs' });
      }
      let validator: boolean = (this.frmOsy.errors?.['required'] == true) ? false : true;
      this.valid.emit(validator);
    }
  }
  ngOnInit(): void {
    let sectionId: number = 25;
    this.inaService.inaSelectionSubject$.subscribe(x => {
      this.section = x.inaSchoolEnrollment.Sections.find(x => x.SectionID == sectionId)!;
      this.inaStatusTypeId = x.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId;
    });

    this.inaService.inaHistorySelectionSubject$.subscribe((x: TrackingHistories) => {
      if (x.inaHistory?.length >= 1) {
        this.trackHistories.inaHistory = x.inaHistory.filter(x => x.ChangedField.split(',')[0] == sectionId.toString());
      }

    });

    if (this.action == INAAction.View) {
      this.frmOsy.disable();
    }
    else {
      this.changeDetection();
      this.frmOsy.valueChanges.subscribe(() => {
        this.updateChangeValue();
      });
    }
    setTimeout(() => {
      this.frmOsy.reset();
      this.setFormValue();
      if (this.action == INAAction.View) {
        this.frmOsy.disable();
      }
    }, 1000);
  }


  setFormValue() {

    this.getListQuestionValueData(376, 'Married/Partner?').forEach(
      x => {
        if (x.Name == 'Yes' && x.Value == 'True')
          this.radioMarriedPartner.setValue("1");
        else if (x.Name == 'No' && x.Value == 'True')
          this.radioMarriedPartner.setValue("2");

      }
    );
    this.getListQuestionValueData(379, 'Children?').forEach(
      x => {
        if (x.Name == 'Yes' && x.Value == 'True')
          this.radioChildren.setValue("1");
        else if (x.Name == 'No' && x.Value == 'True')
          this.radioChildren.setValue("2");
      }

    );
    this.gradeAttended.setValue(this.getQuestionValue(382, 'Last grade attended'));
    this.where.setValue(this.getQuestionValue(383, 'Where?'));
    this.getListQuestionValueData(384, 'Speaking').forEach(
      x => {
        if (x.Name == 'High') {
          if (x.Value == 'True')
            this.radioSpeaking.setValue("1");
        }
        else if (x.Name == 'Medium') {
          if (x.Value == 'True')
            this.radioSpeaking.setValue("2");
        }
        else if (x.Name == 'Low') {
          if (x.Value == 'True')
            this.radioSpeaking.setValue("3");
        }
        else if (x.Name == 'None') {
          if (x.Value == 'True')
            this.radioSpeaking.setValue("4");
        }
      }
    );
    this.getListQuestionValueData(389, 'Reading').forEach(
      x => {
        if (x.Name == 'High') {
          if (x.Value == 'True')
            this.radioReading.setValue("1");
        }
        else if (x.Name == 'Medium') {
          if (x.Value == 'True')
            this.radioReading.setValue("2");
        }
        else if (x.Name == 'Low') {
          if (x.Value == 'True')
            this.radioReading.setValue("3");
        }
        else if (x.Name == 'None') {
          if (x.Value == 'True')
            this.radioReading.setValue("4");
        }
      }
    );
    this.getListQuestionValueData(394, 'Writing').forEach(
      x => {
        if (x.Name == 'High') {
          if (x.Value == 'True')
            this.radioWriting.setValue("1");
        }
        else if (x.Name == 'Medium') {
          if (x.Value == 'True')
            this.radioWriting.setValue("2");
        }
        else if (x.Name == 'Low') {
          if (x.Value == 'True')
            this.radioWriting.setValue("3");
        }
        else if (x.Name == 'None') {
          if (x.Value == 'True')
            this.radioWriting.setValue("4");
        }
      }
    );
    this.getListQuestionValueData(399, 'Preferred Language').forEach(
      x => {
        if (x.Name == 'Spanish') {
          if (x.Value == 'True') {
            this.radioPreferred.setValue("1");
            this.preferredOther.setValue('');
            this.preferredOther.disable();
          }
        }
        else if (x.Name == 'English') {
          if (x.Value == 'True') {
            this.radioPreferred.setValue("2");
            this.preferredOther.setValue('');
            this.preferredOther.disable();
          }
        }
        else if (x.Name == 'Other') {
          if (x.Value == 'True') {
            this.radioPreferred.setValue("3");
            this.preferredOther.setValue('');
            this.preferredOther.enable();
          }
        }
        else if (x.Name == 'Comments') {
          if (this.radioPreferred.value == "3")
            this.preferredOther.setValue(x.Value);
          else
            this.preferredOther.setValue('');
        }
      }
    );

    this.getListQuestionValueData(404, 'Youth is').forEach(
      x => {
        if (x.Name == 'Here-to-work') {
          if (x.Value == 'True') {
            this.radioYouth.setValue("1");
            this.chkContracted.enable();
          }
        }
        else if (x.Name == 'Credit Recovery') {
          if (x.Value == 'True') {
            this.radioYouth.setValue("2");
            this.chkContracted.disable();
          }
        }
        else if (x.Name == 'Contracted') {
          if (x.Value == 'True')
            this.chkContracted.setValue("3");
        }

      }
    );
    this.getListQuestionValueData(408, 'Access to transportation').forEach(
      x => {
        if (x.Name == 'Yes') {
          if (x.Value == 'True') {
            this.radioAccessTT.setValue("1");
            this.accessTT.enable();
          }
        }
        else if (x.Name == 'No') {
          if (x.Value == 'True')
            this.radioAccessTT.setValue("2");
        }
        else if (x.Name == 'Type' && this.radioAccessTT.value == "1") {
          this.accessTT.setValue(x.Value);
        }

      }
    );

    this.getListQuestionValueData(412, 'Type of Housing - Youth lives in').forEach(
      x => {
        if (x.Name == 'Farmworker housing') {
          if (x.Value == 'True')
            this.radioTypeOfHousing.setValue("1");
        }
        else if (x.Name == 'Transitional/Homeless') {
          if (x.Value == 'True')
            this.radioTypeOfHousing.setValue("2");
        }
        else if (x.Name == 'Hotel/Motel') {
          if (x.Value == 'True')
            this.radioTypeOfHousing.setValue("3");
        }
        else if (x.Name == 'House/Apartment') {
          if (x.Value == 'True')
            this.radioTypeOfHousing.setValue("4");
        }


      }
    );

    this.youthlivesWithOther.disable();
    this.getListQuestionValueData(417, 'Youth lives with (Mark all that apply)').forEach(
      x => {
        if (x.Name == 'With a crew') {
          if (x.Value == 'True')
            this.chkWithaCrew.setValue(true);
        }
        else if (x.Name == 'With friends outside of work') {
          if (x.Value == 'True')
            this.chkWithFriends.setValue(true);
        }
        else if (x.Name == 'With parents/relatives') {
          if (x.Value == 'True')
            this.chkWithParents.setValue(true);
        }
        else if (x.Name == 'With spouse/children') {
          if (x.Value == 'True')
            this.chkSpouseChildren.setValue(true);
        }
        else if (x.Name == 'Other') {
          if (x.Value == 'True') {
            this.chkYouthLivesOther.setValue(true);
            this.youthlivesWithOther.enable();
          }
        }
        else if (x.Name == 'Comments') {
          if (this.chkYouthLivesOther.value == true)
            this.youthlivesWithOther.setValue(x.Value);
          else
            this.youthlivesWithOther.setValue('');
        }


      }
    );
    this.interestedOther.disable();
    this.getListQuestionValueData(424, 'Interested in').forEach(
      x => {
        if (x.Name == 'English (ELA, ESL, ELD)') {
          if (x.Value == 'True')
            this.chkElaEslELD.setValue(true);
        }
        else if (x.Name == 'GED/HEP') {
          if (x.Value == 'True')
            this.chkGedHep.setValue(true);
        }
        else if (x.Name == 'Home language literacy') {
          if (x.Value == 'True')
            this.chkHomeLanguage.setValue(true);
        }
        else if (x.Name == 'Job training/CTE') {
          if (x.Value == 'True')
            this.chkJobTraining.setValue(true);
        }
        else if (x.Name == 'Other') {
          if (x.Value == 'True') {
            this.chkInterestedOther.setValue(true);
            this.interestedOther.enable();
          }
        }
        else if (x.Name == 'Comments') {
          if (this.chkInterestedOther.value == true) 
            this.interestedOther.setValue(x.Value);          
          else
            this.interestedOther.setValue('');

        }
        else if (x.Name == 'None') {
          if (x.Value == 'True')
            this.chkInterestedNone.setValue(true);
        }


      }
    );
    this.availabilityOther.disable();
    this.getListQuestionValueData(432, 'Availability').forEach(
      x => {
        if (x.Name == 'Days') {
          if (x.Value == 'True')
            this.chkDays.setValue(true);
        }
        else if (x.Name == 'Evenings') {
          if (x.Value == 'True')
            this.chkEvenings.setValue(true);
        }
        else if (x.Name == 'Saturday') {
          if (x.Value == 'True')
            this.chkSaturday.setValue(true);
        }
        else if (x.Name == 'Sunday') {
          if (x.Value == 'True')
            this.chkSunday.setValue(true);
        }
        else if (x.Name == 'Other') {
          if (x.Value == 'True') {
            this.chkAvailabilityOther.setValue(true);
            this.availabilityOther.enable();
          }
        }
        else if (x.Name == 'Comments') {
          if(this.chkAvailabilityOther.value==true)
            this.availabilityOther.setValue(x.Value);
          else  
          this.availabilityOther.setValue('');

        }
      }
    );
    this.interviewOther.disable();
    this.getListQuestionValueData(439, 'At interview, youth received').forEach(
      x => {
        if (x.Name == 'Educational materials') {
          if (x.Value == 'True')
            this.chkEducational.setValue(true);
        }
        else if (x.Name == 'Health kit') {
          if (x.Value == 'True')
            this.chkHealth.setValue(true);
        }
        else if (x.Name == 'Referral/Community Resources') {
          if (x.Value == 'True')
            this.chkReferralCommunity.setValue(true);
        }
        else if (x.Name == 'Other') {
          if (x.Value == 'True') {
            this.chkInterviewOther.setValue(true);
            this.interviewOther.enable();
          }
        }
        else if (x.Name == 'Comments') {
          if(this.chkInterviewOther.value==true)          
            this.interviewOther.setValue(x.Value);
          else
            this.interviewOther.setValue('');

        }
      }
    );

    this.emergencyContact.setValue(this.getQuestionValue(445, 'Emergency Contact'));
    this.relationship.setValue(this.getQuestionValue(446, 'Relationship'));
    this.phone.setValue(this.getQuestionValue(447, 'Phone'));
    this.fireValidation();
  }
  changeDetection() {
    this.radioPreferred.valueChanges.subscribe((x: any) => {
      if (x == 3) {
        this.preferredOther.enable();
      }
      else {
        this.preferredOther.disable();
        this.preferredOther.setValue('');
      }

    });
    this.radioYouth.valueChanges.subscribe((x: any) => {
      if (x == 1)
        this.chkContracted.enable();
      else {
        this.chkContracted.setValue(false);
        this.chkContracted.disable();
      }

    })
    this.radioAccessTT.valueChanges.subscribe((x: any) => {
      if (x == "2") {
        this.accessTT.disable();
        this.accessTT.setValue('');
      }
      else {
        this.accessTT.setValue('');
        this.accessTT.enable();
      }
    })
    this.chkYouthLivesOther.valueChanges.subscribe((x: any) => {
      if (x == true)
        this.youthlivesWithOther.enable();
      else {
        this.youthlivesWithOther.setValue('');
        this.youthlivesWithOther.disable();
      }
    })


    this.chkAvailabilityOther.valueChanges.subscribe((x: any) => {
      if (x == true)
        this.availabilityOther.enable();
      else {
        this.availabilityOther.setValue('');
        this.availabilityOther.disable();
      }
    })

    this.chkInterestedOther.valueChanges.subscribe((x: any) => {
      if (x == true)
        this.interestedOther.enable();
      else {
        this.interestedOther.setValue('');
        this.interestedOther.disable();
      }
    })
    
    this.chkInterviewOther.valueChanges.subscribe((x: any) => {
      if (x == true)
        this.interviewOther.enable();
      else {
        this.interviewOther.setValue('');
        this.interviewOther.disable();
      }
    })
  }
  getListQuestionValueData(questionId: number, questionName: string): LstQuestionValueDataView[] {
    {
      return this.shared.getListQuestionValueData(this.section, questionId, questionName);
    }

  }
  getQuestionValue(questionId: number, questionName: string): string {
    return this.shared.getQuestionValue(this.section, questionId, questionName);
  }


  /*  setStep(index: number) {
      this.step = index;
      let s: StepAction = new StepAction();
      s.stepNumber = this.step;
      this.prevOrNextStep.emit(s);
    }
  
    nextStep() {
      this.notifyAction = 'Next';
      this.notifyChanges(0);
    }
  
    prevStep() {
      this.notifyAction = 'Prev';
      this.notifyChanges(0);
    }
  
    notifyChanges(action: number) {
      if (action == 1 && this.notifyAction.length >= 1) {  //avoid calling duplicates when closed event is fired
        this.notifyAction = '';
      }
      else {
        let s: StepAction = new StepAction();
        s.stepNumber = this.step;
        s.action = this.notifyAction;
        s.section = new Section();
        if (this.frmOsy.dirty) {
          this.updateChangeValue();
          s.section = this.section;
          s.lsttrackingHistory=this.lstTrackHistory;
          this.lstTrackHistory=[];
          this.prevOrNextStep.emit(s);
        }
        else
          this.prevOrNextStep.emit(s);
      }
    }
    */

  updateChangeValueLostFocus() {
    if (this.where.dirty) {
      this.setListQuestionValue(383, 'Where?', this.where.value)
      this.where.markAsPristine();
    }
    if (this.accessTT.dirty) {
      this.setListQuestionValue(408, 'Type', this.accessTT.value);
      this.accessTT.markAsPristine();
    }
    if (this.preferredOther.dirty) {
      this.setListQuestionValue(399, 'Comments', this.preferredOther.value);
      this.preferredOther.markAsPristine();
    }
    if (this.youthlivesWithOther.dirty) {
      this.setListQuestionValue(417, 'Comments', this.youthlivesWithOther.value);
      this.youthlivesWithOther.markAsPristine();
    }
    if (this.interestedOther.dirty) {
      this.setListQuestionValue(424, 'Comments', this.interestedOther.value);

      this.interestedOther.markAsPristine();
    }
    if (this.availabilityOther.dirty) {
      this.setListQuestionValue(432, 'Comments', this.availabilityOther.value);

      this.availabilityOther.markAsPristine();
    }
    if (this.interviewOther.dirty) {
      this.setListQuestionValue(439, 'Comments', this.interviewOther.value);

      this.interviewOther.markAsPristine();
    }
    if (this.phone.dirty && this.phone.valid) {
      this.setListQuestionValue(447, 'Phone', this.phone.value);

      this.phone.markAsPristine();
    }
  }

  updateChangeValue() {
    let radioVal: string = '';
    if (this.radioMarriedPartner.dirty) {
      let radioVal: string = '';
      if (this.radioMarriedPartner.dirty) {
        radioVal = this.radioMarriedPartner.value;
        this.setRadioValue(376, 'Yes', radioVal);

        this.radioMarriedPartner.markAsPristine();
      }
    }
    else if (this.radioChildren.dirty) {
      let radioVal: string = '';
      if (this.radioChildren.dirty) {
        radioVal = this.radioChildren.value;
        this.setRadioValue(379, 'Yes', radioVal);

        this.radioChildren.markAsPristine();
      }
    }
    else if (this.gradeAttended.dirty) {
      this.setListQuestionValue(382, 'Last grade attended', this.gradeAttended.value);

      this.gradeAttended.markAsPristine();
    }

    else if (this.radioSpeaking.dirty) {
      radioVal = this.radioSpeaking.value;
      this.setRadioValue(384, 'High', radioVal);
      this.radioSpeaking.markAsPristine();
    }
    else if (this.radioReading.dirty) {
      radioVal = this.radioReading.value;
      this.setRadioValue(389, 'High', radioVal);
      this.radioReading.markAsPristine();
    }
    else if (this.radioWriting.dirty) {
      radioVal = this.radioWriting.value;
      this.setRadioValue(394, 'High', radioVal);
      this.radioWriting.markAsPristine();
    }
    else if (this.radioPreferred.dirty) {
      radioVal = this.radioPreferred.value;
      this.setRadioValue(399, 'Spanish', radioVal);
      this.radioPreferred.markAsPristine();
    }

    else if (this.radioYouth.dirty) {
      radioVal = this.radioYouth.value;
      this.setRadioValue(404, 'Here-to-work', radioVal);
      this.radioYouth.markAsPristine();
    }
    else if (this.chkContracted.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkContracted.value == 1 ? "True" : "False";
      this.setListQuestionValue(404, 'Contracted', checkBoxVal);

      this.chkContracted.markAsPristine();
    }

    else if (this.radioAccessTT.dirty) {
      radioVal = this.radioAccessTT.value;
      this.setRadioValue(408, 'Yes', radioVal);
      this.radioAccessTT.markAsPristine();
    }

    else if (this.radioTypeOfHousing.dirty) {
      radioVal = this.radioTypeOfHousing.value;
      this.setRadioValue(412, 'Farmworker housing', radioVal);

      this.radioTypeOfHousing.markAsPristine();
    }

    else if (this.chkWithaCrew.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkWithaCrew.value == 1 ? "True" : "False";
      this.setListQuestionValue(417, 'With a crew', checkBoxVal);

      this.chkWithaCrew.markAsPristine();
    }

    else if (this.chkWithFriends.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkWithFriends.value == 1 ? "True" : "False";
      this.setListQuestionValue(417, 'With friends outside of work', checkBoxVal);

      this.chkWithFriends.markAsPristine();
    }
    else if (this.chkWithParents.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkWithParents.value == 1 ? "True" : "False";
      this.setListQuestionValue(417, 'With parents/relatives', checkBoxVal);

      this.chkWithParents.markAsPristine();
    }
    else if (this.chkSpouseChildren.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkSpouseChildren.value == 1 ? "True" : "False";
      this.setListQuestionValue(417, 'With spouse/children', checkBoxVal);

      this.chkSpouseChildren.markAsPristine();
    }
    else if (this.chkYouthLivesOther.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkYouthLivesOther.value == 1 ? "True" : "False";
      this.setListQuestionValue(417, 'Other', checkBoxVal);
      this.chkYouthLivesOther.markAsPristine();
      //changes
    }

    else if (this.chkElaEslELD.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkElaEslELD.value == 1 ? "True" : "False";
      this.setListQuestionValue(424, 'English (ELA, ESL, ELD)', checkBoxVal);

      this.chkElaEslELD.markAsPristine();
    }
    else if (this.chkGedHep.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkGedHep.value == 1 ? "True" : "False";
      this.setListQuestionValue(424, 'GED/HEP', checkBoxVal);

      this.chkGedHep.markAsPristine();
    }
    else if (this.chkHomeLanguage.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkHomeLanguage.value == 1 ? "True" : "False";
      this.setListQuestionValue(424, 'Home language literacy', checkBoxVal);

      this.chkHomeLanguage.markAsPristine();
    }
    else if (this.chkJobTraining.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkJobTraining.value == 1 ? "True" : "False";
      this.setListQuestionValue(424, 'Job training/CTE', checkBoxVal);

      this.chkJobTraining.markAsPristine();
    }
    else if (this.chkInterestedOther.dirty) {
      
      let checkBoxVal: string = '';
      checkBoxVal = this.chkInterestedOther.value == 1 ? "True" : "False";
      this.setListQuestionValue(424, 'Other', checkBoxVal);
      this.chkInterestedOther.markAsPristine();
      
    }

    else if (this.chkInterestedNone.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkInterestedNone.value == 1 ? "True" : "False";
      this.setListQuestionValue(424, 'None', checkBoxVal);

      this.chkInterestedNone.markAsPristine();
    }
    else if (this.chkDays.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkDays.value == 1 ? "True" : "False";
      this.setListQuestionValue(432, 'Days', checkBoxVal);

      this.chkDays.markAsPristine();
    }
    else if (this.chkEvenings.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkEvenings.value == 1 ? "True" : "False";
      this.setListQuestionValue(432, 'Evenings', checkBoxVal);

      this.chkEvenings.markAsPristine();
    }
    else if (this.chkSaturday.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkSaturday.value == 1 ? "True" : "False";
      this.setListQuestionValue(432, 'Saturday', checkBoxVal);

      this.chkSaturday.markAsPristine();
    }
    else if (this.chkSunday.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkSunday.value == 1 ? "True" : "False";
      this.setListQuestionValue(432, 'Sunday', checkBoxVal);

      this.chkSunday.markAsPristine();
    }
    else if (this.chkAvailabilityOther.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkAvailabilityOther.value == 1 ? "True" : "False";
      this.setListQuestionValue(432, 'Other', checkBoxVal);
      this.chkAvailabilityOther.markAsPristine();


    }

    else if (this.chkEducational.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkEducational.value == 1 ? "True" : "False";
      this.setListQuestionValue(439, 'Educational materials', checkBoxVal);

      this.chkEducational.markAsPristine();
    }
    else if (this.chkHealth.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkHealth.value == 1 ? "True" : "False";
      this.setListQuestionValue(439, 'Health kit', checkBoxVal);

      this.chkHealth.markAsPristine();
    }
    else if (this.chkReferralCommunity.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkReferralCommunity.value == 1 ? "True" : "False";
      this.setListQuestionValue(439, 'Referral/Community Resources', checkBoxVal);

      this.chkReferralCommunity.markAsPristine();
    }
    else if (this.chkInterviewOther.dirty) {
      let checkBoxVal: string = '';
      checkBoxVal = this.chkInterviewOther.value == 1 ? "True" : "False";
      this.setListQuestionValue(439, 'Other', checkBoxVal);

      this.chkInterviewOther.markAsPristine();
    }

    else if (this.emergencyContact.dirty) {
      this.setListQuestionValue(445, 'Emergency Contact', this.emergencyContact.value);

      this.emergencyContact.markAsPristine();
    }
    else if (this.relationship.dirty) {
      this.setListQuestionValue(446, 'Relationship', this.relationship.value);

      this.relationship.markAsPristine();
    }

  }



  setRadioValue(questionId: number, questionName: string, value: string) {
    this.setTrackingHistory(questionId, questionName, value);
    this.shared.setRadioValue(this.section, questionId, value);
    this.fireValidation();
    //this.shared.updateCacheSection(this.section);        
  }

  setListQuestionValue(questionId: number, questionName: string, value: string) {
    this.setTrackingHistory(questionId, questionName, value);
    this.shared.setListQuestionValue(this.section, questionId, questionName, value);
    this.fireValidation();
    //this.shared.updateCacheSection(this.section);    
  }
  setTrackingHistory(questionId: number, questionName: string, value: string) {
    if (this.inaStatusTypeId == 2) {
      var tempTrackingHistory: TrackingHistory = this.shared.setTrackingHistory(this.section, questionId, questionName, value);
      this.updateHistory.emit(tempTrackingHistory);
    }
  }

  get radioMarriedPartner(): any { return this.frmOsy.get('radioMarriedPartner'); }
  get radioChildren(): any { return this.frmOsy.get('radioChildren'); }
  get gradeAttended(): any { return this.frmOsy.get('gradeAttended'); }
  get where(): any { return this.frmOsy.get('where'); }
  get radioSpeaking(): any { return this.frmOsy.get('radioSpeaking'); }
  get radioReading(): any { return this.frmOsy.get('radioReading'); }
  get radioWriting(): any { return this.frmOsy.get('radioWriting'); }
  get radioPreferred(): any { return this.frmOsy.get('radioPreferred'); }
  get preferredOther(): any { return this.frmOsy.get('preferredOther'); }
  get radioYouth(): any { return this.frmOsy.get('radioYouth'); }
  get chkContracted(): any { return this.frmOsy.get('chkContracted'); }
  get radioAccessTT(): any { return this.frmOsy.get('radioAccessTT'); }
  get accessTT(): any { return this.frmOsy.get('accessTT'); }
  get radioTypeOfHousing(): any { return this.frmOsy.get('radioTypeOfHousing'); }
  //get radioYouthlivesWith(): any { return this.frmOsy.get('radioYouthlivesWith'); }
  get chkWithaCrew(): any { return this.frmOsy.get('chkWithaCrew'); }
  get chkWithFriends(): any { return this.frmOsy.get('chkWithFriends'); }
  get chkWithParents(): any { return this.frmOsy.get('chkWithParents'); }
  get chkSpouseChildren(): any { return this.frmOsy.get('chkSpouseChildren'); }
  get chkYouthLivesOther(): any { return this.frmOsy.get('chkYouthLivesOther'); }

  get youthlivesWithOther(): any { return this.frmOsy.get('youthlivesWithOther'); }
  get chkElaEslELD(): any { return this.frmOsy.get('chkElaEslELD'); }
  get chkGedHep(): any { return this.frmOsy.get('chkGedHep'); }
  get chkHomeLanguage(): any { return this.frmOsy.get('chkHomeLanguage'); }
  get chkJobTraining(): any { return this.frmOsy.get('chkJobTraining'); }
  get chkInterestedOther(): any { return this.frmOsy.get('chkInterestedOther'); }
  get interestedOther(): any { return this.frmOsy.get('interestedOther'); }
  get chkInterestedNone(): any { return this.frmOsy.get('chkInterestedNone'); }
  get chkDays(): any { return this.frmOsy.get('chkDays'); }
  get chkEvenings(): any { return this.frmOsy.get('chkEvenings'); }
  get chkSaturday(): any { return this.frmOsy.get('chkSaturday'); }
  get chkSunday(): any { return this.frmOsy.get('chkSunday'); }
  get chkAvailabilityOther(): any { return this.frmOsy.get('chkAvailabilityOther'); }
  get availabilityOther(): any { return this.frmOsy.get('availabilityOther'); }
  get chkEducational(): any { return this.frmOsy.get('chkEducational'); }
  get chkHealth(): any { return this.frmOsy.get('chkHealth'); }
  get chkReferralCommunity(): any { return this.frmOsy.get('chkReferralCommunity'); }
  get chkInterviewOther(): any { return this.frmOsy.get('chkInterviewOther'); }
  get interviewOther(): any { return this.frmOsy.get('interviewOther'); }
  get emergencyContact(): any { return this.frmOsy.get('emergencyContact'); }
  get relationship(): any { return this.frmOsy.get('relationship'); }
  get phone(): any { return this.frmOsy.get('phone'); }

}
